"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonStyled = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const core_1 = require("@material-ui/core");
const ButtonDefault = styled_components_1.default(core_1.Button) `
  font-size: 16px;
  height: 50px;
  cursor: pointer;
`;
exports.ButtonStyled = styled_components_1.default((_a) => {
    var // rounded,
    // circle,
    // primary,
    // secondary,
    // light,
    // outlinePrimary,
    // outlineSecondary,
    otherProps = __rest(_a, []);
    return react_1.default.createElement(ButtonDefault, Object.assign({}, otherProps));
}).attrs(props => (Object.assign({ disabled: !!props.loading }, props))) `
  ${props => props.rounded &&
    styled_components_1.css `
      border-radius: 25px;
      padding: 5px 20px;
    `}

  ${props => props.circle &&
    styled_components_1.css `
      border-radius: 50%;
      padding: 5px 20px;
      font-weight: bold;
      min-width: unset;
    `}

${props => props.primary &&
    !props.disabled &&
    styled_components_1.css `
      background: ${({ theme }) => theme.palette.primary.main};
      color: white;

      &:hover {
        background: ${({ theme }) => theme.palette.primary.dark};
        font-weight: bold;
      }
    `}

${props => props.secondary &&
    !props.disabled &&
    styled_components_1.css `
      background: ${({ theme }) => theme.palette.secondary.main};
      color: white;

      &:hover {
        background: ${({ theme }) => theme.palette.secondary.dark};
        font-weight: bold;
      }
    `}

${props => props.disabled &&
    styled_components_1.css `
      background: ${({ theme }) => theme.palette.action.disabledBackground};
      color: ${({ theme }) => theme.palette.action.disabled};
    `}

${props => props.light &&
    styled_components_1.css `
      background: white;
      color: ${({ theme }) => theme.palette.primary.selected};

      &:hover {
        background: ${({ theme }) => theme.palette.primary.selected};
        color: white;
      }
    `}

  ${props => props.outlinePrimary &&
    styled_components_1.css `
      border: 1px solid ${({ theme }) => theme.palette.primary.main};
      color: ${({ theme }) => theme.palette.primary.main};
    `}

  ${props => props.outlineSecondary &&
    styled_components_1.css `
      border: 1px solid ${({ theme }) => theme.palette.secondary.main};
      color: ${({ theme }) => theme.palette.secondary.main};
    `}
`;
//# sourceMappingURL=styles.js.map